import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

export default class BlacklistService extends CrudRequest {
  static baseUrl() {
    return 'account/black-list';
  }

  static remove(payload) {
    httpService.interceptors.request.use(
      (req) => {
        const config = req;

        if (config.url === this.baseUrl() && config.method === 'delete') {
          config.data = payload;
        }

        return config;
      },
    );

    return httpService.delete(
      this.baseUrl(),
      {
        data: payload,
      },
    );
  }
}
